:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._mt-t-space-med104641{margin-top:var(--t-space-medium);}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}
:root ._mr-t-space-sma3456{margin-right:var(--t-space-small);}
:root ._ml-t-space-sma3456{margin-left:var(--t-space-small);}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._items-center{align-items:center;}
:root ._bg-white{background-color:white;}
:root ._btw-1px{border-top-width:1px;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._borderTopStyle-solid{border-top-style:solid;}